<template>
  <q-card flat v-if="customerList.length>0">
    <q-card-section class="no-padding" v-if="isDialog">
      <q-banner inline-actions class="bg-blue text-white">
        {{ title }}
        <template v-slot:action>
          <q-btn flat v-close-popup icon="close" round/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section v-if="customerList.length>0" class="no-padding">
      <q-chip dense :size="$q.screen.lt.md?'md':'lg'" color="indigo-10" text-color="white"
              square
              label="میزان بدهی">
        <q-chip square color="red-14" text-color="white"
                v-if="!buyList"
                size="sm"
                :label="lodash.sumBy(customerList.filter(item=> item.RemCredit>0 && item.CsSpe_ID===2), item=> item.RemCredit).toLocaleString()"/>
        <q-chip square color="red-14" text-color="white"
                v-if="buyList"
                :label="lodash.sumBy(customerList.filter(item=> item.RemCredit<0), item=> Math.abs(item.RemCredit)).toLocaleString()"/>
      </q-chip>
      <q-space v-if="$q.screen.lt.md"/>
      <vue-json-to-csv
          :json-data="customerList"
          v-if="customerList && customerList.length>0 && $store.state.roles.some(v=>['admin','can_download_list'].includes(v))">
        <q-btn label="دانلود" icon="download" color="blue" flat class="q-ml-sm">
          <download-csv
              name="customers"
              :data="customerList">
            <span></span>
          </download-csv>
          <q-tooltip>
            دانلود گزارش
          </q-tooltip>
        </q-btn>
      </vue-json-to-csv>
      <q-btn v-if="$store.state.roles.some(v=>['admin','can_send_sms'].includes(v))"
             label="ارسال پیامک گروهی"
             icon="send" color="indigo" flat @click="batchSMSDialog=true"/>
      <q-separator/>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-input v-if="isDialog" clearable autofocus v-model="filter" filled label="جستجو در لیست">
        <template v-slot:append>
          <q-btn :dense="$q.screen.lt.md" @click.stop round flat icon="settings" color="blue">
            <q-popup-proxy transition-show="flip-up" transition-hide="flip-down">
              <q-card flat>
                <q-card-section class="q-pa-xs">
                  <q-select
                      :dense="$q.screen.lt.md"
                      :options="cityListOptions"
                      filled
                      label="فیلتر بر حسب شهر"
                      v-model="selectedCities"
                      multiple
                      use-chips
                      clearable
                      use-input
                      @filter="cityFilterFn"
                      class="q-mt-xs"/>
                </q-card-section>
              </q-card>
            </q-popup-proxy>
          </q-btn>
        </template>
      </q-input>
    </q-card-section>
    <q-card-section>
      <q-table
          class="my-sticky-header-table"
          :data="customerList"
          :columns="columns"
          row-key="Cs_Code"
          flat
          bordered
          wrap-cells
          separator="cell"
          binary-state-sort
          :filter="filter"
          :pagination="pagination">
        <template v-slot:body="props">
          <q-tr :props="props" class="text-bold">
            <td>
              <q-toggle :true-value="1" :false-value="0" v-model="props.row.Checked"/>
            </td>
            <q-td key="Cs_Code" :props="props">
              <q-chip :label="props.row.Cs_Code" square color="red" text-color="white" clickable
                      @click="showCustomerDetails(props.row)"/>
            </q-td>
            <q-td key="Cs_Begin" :props="props">
              {{ props.row.Cs_Begin }}
            </q-td>
            <q-td key="Sale_Pay" :props="props" class="text-bold">
              {{ props.row.Sale_Pay?props.row.Sale_Pay.toLocaleString():0 }}
            </q-td>
            <q-td key="Cs_FirName" :props="props">
              {{ props.row.Cs_FirName }}
            </q-td>
            <q-td key="Cs_FamName" :props="props">
              {{ props.row.Cs_FamName }}
            </q-td>
            <q-td key="Cs_ShopName" :props="props">
              {{ props.row.Cs_ShopName && props.row.Cs_ShopName !== 'None' ? props.row.Cs_ShopName : '' }}
            </q-td>
            <q-td key="CSKind_Name" :props="props">
              {{ props.row.CSKind_Name }}
            </q-td>
            <q-td key="State_Name" :props="props">
              {{ props.row.State_Name }}
            </q-td>
            <q-td key="City_Name" :props="props">
              {{ props.row.City_Name }}
            </q-td>
            <q-td key="Cs_Tel1" :props="props" class="text-bold">
              {{ props.row.Cs_Tel1 }}
            </q-td>
            <q-td key="Cs_Mobile" :props="props" class="text-bold">
              <q-btn flat color="purple" padding="none"
                     :label="props.row.Cs_Mobile"
                     @click="dial(props.row.Cs_Mobile, props.row)">
                <q-tooltip>
                  نماس
                </q-tooltip>
              </q-btn>
            </q-td>
            <q-td key="Fact_Date" class="text-bold text-deep-orange-10" :props="props">
              {{ props.row.Fact_Date }}
            </q-td>
            <q-td key="RemCredit" :props="props"
                  :class="props.row.RemCredit>0?'text-bold text-red':'text-bold text-green'">
              {{ props.row.RemCredit ? props.row.RemCredit.toLocaleString() : '' }}
            </q-td>
            <q-td key="AgentRegisterInfo" :props="props">
              {{ props.row.AgentRegisterInfo }}
            </q-td>
            <q-td key="PersianVisitDateTime" :props="props">
              {{ props.row.PersianVisitDateTime }}
            </q-td>
            <q-td key="VisitComment" :props="props" class="ellipsis" style="max-width: 250px">
              {{ props.row.VisitComment }}
            </q-td>
            <q-td key="Cs_Desc" :props="props" class="ellipsis" style="max-width: 250px">
              {{ props.row.Cs_Desc && props.row.Cs_Desc !== 'None' ? props.row.Cs_Desc : '' }}
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>
    <q-dialog
        :maximized="$q.screen.lt.md"
        v-model="showCustomerFullInfo">
      <customer-info :selectedCustomer="this.selectedCustomer" :buy-list="buyList"
                     @customer-updated="customerUpdated"/>
    </q-dialog>
    <q-dialog
        :maximized="$q.screen.lt.md"
        v-model="showOrderHistoryList">
      <q-card>
        <q-card-section class="row items-center q-pb-none">
          <div>
            <div class="text-bold">سوابق سفارشات <i class="text-indigo-14">{{
                selectedCustomer.Cs_Name
              }}</i></div>
            <q-badge align="top" class="bg-red-14"><i>شناسه(</i><b>{{
                selectedCustomer.Cs_Code
              }}</b><i>)</i>
            </q-badge>
          </div>
          <q-space/>
          <q-btn icon="close" flat round dense v-close-popup/>
        </q-card-section>
        <q-card-section>
          <OrderHistory default-sale-state="0" :order-history-list="orderHistoryList"/>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="showSMSPanel">
      <SMSPanel :customer="selectedCustomer" :share="share" @sms_sended="sms_sended"/>
    </q-dialog>
    <q-dialog
        :maximized="$q.screen.lt.md"
        v-model="showVisitLogDialog">
      <visit-log :selectedCustomer="this.selectedCustomer"/>
    </q-dialog>
    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showEventDialog">
      <q-card>
        <q-card-section>
          <CUVisitLog @event-added="closeEventDialog" :selected-customer="this.selectedCustomer"/>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog
        v-model="showFinanceInfoDialog"
        :maximized="$q.screen.lt.md">
      <CustomerFinanceInfo :customer-info="selectedCustomer"/>
    </q-dialog>
    <q-dialog v-model="showCallPanelDialog" :full-width="$q.screen.lt.md">
      <CallPanel :is-dialog="true" :customer-info="selectedCustomer" :call-number="callNumber"/>
    </q-dialog>
    <q-dialog v-model="customerReceivePayList" :maximized="$q.screen.lt.md">
      <CustomerReceiveList :customer-info="selectedCustomer"/>
    </q-dialog>
    <q-dialog v-model="batchSMSDialog" v-if="customerList.filter(item=> item.Checked).length>0">
      <SMSPanel :customers="customerList.filter(item=> item.Checked)" :share="false" :multiple="true"
                @sms_sended="sms_sended"/>
    </q-dialog>
    <q-dialog v-model="customerQuestionaire" maximized>
      <CustomerQuestions :customer-info="selectedCustomer"/>
    </q-dialog>
    <q-dialog v-model="customerValueDialog">
      <CustomerRFMTrace :customer-info="selectedCustomer"/>
    </q-dialog>
  </q-card>
</template>

<script>
import EventBus from "@/event-bus";
import CustomerInfo from "@/components/customers/CustomerInfo";
import {mapActions} from "vuex";
import OrderHistory from "@/components/customers/OrderHistory";
import SMSPanel from "@/components/callCenter/SMSPanel";
import VisitLog from "@/components/customers/VisitLog";
import CUVisitLog from "@/components/customers/CUVisitLog";
import CustomerFinanceInfo from "@/components/customers/CustomerFinanceInfo";
import CallPanel from "@/components/callCenter/CallPanel";
import CustomerReceiveList from "@/components/customers/CustomerReceiveList";
import VueJsonToCsv from 'vue-json-to-csv'
import CustomerQuestions from "@/components/CustomerQuestions/CustomerQuestions";
import CustomerRFMTrace from "@/components/customers/CustomerRFMTrace.vue";

export default {
  name: "CustomersListSimple",
  components: {
    CustomerRFMTrace,
    CustomerQuestions,
    CustomerReceiveList,
    CallPanel, CustomerFinanceInfo, CUVisitLog, VisitLog, SMSPanel, OrderHistory, CustomerInfo, VueJsonToCsv
  },
  props: {
    isBuyAndSaleList: {
      type: Boolean,
      default: () => false
    },
    buyList: {
      type: Boolean
    },
    title: {
      type: String,
      required: false,
      default: 'لیست'
    },
    isOnlySearchList: {
      type: Boolean,
      defaults: false
    },
    isDialog: {
      type: Boolean,
      required: true,
      default: false
    },
    items: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      columns: [
        {},
        {
          name: 'Cs_Code',
          required: true,
          label: 'شناسه',
          align: 'center',
          field: row => row.Cs_Code,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'Cs_Begin',
          required: true,
          label: 'شروع فعالیت',
          align: 'center',
          field: row => row.Cs_Begin,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'Sale_Pay',
          required: true,
          label: 'جمع معاملات',
          align: 'center',
          field: row => row.Sale_Pay,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'Cs_FirName',
          required: true,
          label: 'نام',
          align: 'center',
          field: row => row.Cs_FirName,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'Cs_FamName',
          required: true,
          label: 'نام خانوادگی',
          align: 'center',
          field: row => row.Cs_FamName,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'Cs_ShopName',
          required: true,
          label: 'عنوان فروشگاه',
          align: 'center',
          field: row => row.Cs_ShopName,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'CSKind_Name',
          required: true,
          label: 'صنف',
          align: 'center',
          field: row => row.CSKind_Name,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'State_Name',
          required: true,
          label: 'استان',
          align: 'center',
          field: row => row.State_Name,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'City_Name',
          required: true,
          label: 'شهر',
          align: 'center',
          field: row => row.City_Name,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'Cs_Tel1',
          required: true,
          label: 'تلفن',
          align: 'center',
          field: row => row.Cs_Tel1,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'Cs_Mobile',
          required: true,
          label: 'موبایل',
          align: 'center',
          field: row => row.Cs_Mobile,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'Fact_Date',
          required: true,
          label: 'آخرین خرید',
          align: 'center',
          field: row => row.Fact_Date,
          format: val => `${(val ? val.trim() : '')}`,
          sortable: true,
        },
        {
          name: 'RemCredit',
          required: true,
          label: 'مانده بدهی',
          align: 'center',
          field: row => row.RemCredit,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'AgentRegisterInfo',
          required: true,
          label: 'کاربر',
          align: 'center',
          field: row => row.AgentRegisterInfo,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'PersianVisitDateTime',
          required: true,
          label: 'تاریخ آخرین یادداشت',
          align: 'center',
          field: row => row.PersianVisitDateTime,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'VisitComment',
          required: true,
          label: 'آخرین یادداشت',
          align: 'left',
          field: row => row.VisitComment,
          format: val => `${(val ? val.trim() : '')}`,
          sortable: true,
        },
        {
          name: 'Cs_Desc',
          required: true,
          label: 'توضیحات',
          align: 'left',
          field: row => row.Cs_Desc,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
      ],
      customerValueDialog: false,
      customerQuestionaire: false,
      cityListOptions: [],
      cityList: [],
      selectedCities: [],
      batchSMSDialog: false,
      filter: '',
      customerReceivePayList: false,
      showFinanceInfoDialog: false,
      share: false,
      showVisitLogDialog: false,
      showEventDialog: false,
      showSMSPanel: false,
      customerList: [],
      selectedCustomer: '',
      showCustomerFullInfo: false,
      showCustomerEditForm: false,
      orderHistoryList: [],
      showOrderHistoryList: false,
      pagination: {
        sortBy: 'title',
        rowsPerPage: 500
      },
      callNumber: '',
      showCallPanelDialog: false
    }
  },
  methods: {
    ...mapActions({
      ShowOrderHistory: 'Customers/getOrderHistory',
      setCurrentLocation: 'Customers/set_current_location',
      getCustomerInfo: 'Customers/get_customer_info'
    }),
    showCustomerValueTrace(args) {
      this.selectedCustomer = args
      this.customerValueDialog = true
    },
    showQuestionsDialog(args) {
      this.selectedCustomer = args
      this.customerQuestionaire = true
    },
    customerUpdated(args) {
      this.selectedCustomer = args
      this.customerList = this.customerList.filter(item => item.Cs_ID !== args.Cs_ID)
      this.customerList.unshift(args)
    },
    cityFilterFn(val, update) {
      if (val === '') {
        update(() => {
          this.cityListOptions = this.cityList
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        this.cityListOptions = this.cityList.filter(v => v.toLowerCase().indexOf(needle) > -1)
      })
    },
    showActionsButton(row) {
      this.selectedCustomer = row;
      const actionRow = document.getElementById(`actionRow-${row.Cs_Code}`)
      actionRow.style.display = 'block'
    },
    hideActionsButton(row) {
      const actionRow = document.getElementById(`actionRow-${row.Cs_Code}`)
      actionRow.style.display = 'none'
    },
    selectedRow(row) {
      this.selectedCustomer = row;
    },
    showReceivePayList(row) {
      this.selectedCustomer = row;
      this.customerReceivePayList = true;
    },
    dial(number, rowInfo) {
      this.callNumber = number;
      this.selectedCustomer = rowInfo
      this.showCallPanelDialog = true;
    },
    showEvent(row) {
      this.selectedCustomer = row;
      this.showEventDialog = true
    },
    showTimeLine(row) {
      this.selectedCustomer = row;
      this.showVisitLogDialog = true;
    },
    closeEventDialog() {
      this.showEventDialog = false
    },
    sms_sended() {
      this.showSMSPanel = false
      this.batchSMSDialog = false
    },
    shareInfo(userInfo) {
      this.share = true;
      this.selectedCustomer = userInfo
      this.showSMSPanel = true
    },
    showFinanceInfo(row) {
      this.selectedCustomer = row;
      this.showFinanceInfoDialog = true;
    },
    showOrderHistory(row) {
      this.ShowOrderHistory(row.Cs_ID).then((res) => {
        this.selectedCustomer = row;
        this.orderHistoryList = res.data;
        this.showOrderHistoryList = true;
      });
    },
    showDetails(row) {
      if (row.ValidInformation !== 1) {
        this.$q.notify({
          message: 'اطلاعات طرف معامله نادرست است، لطفا ابتدا اطلاعات طرف معامله را اصلاح نموده  و سپس اقدام یه ثبت سفارش نمایید',
          color: 'negative',
          position: 'top',
          type: 'negative',
          multiLine: true
        });
      } else {
        if (row.NotAcceptedOrder !== 0) {
          this.$q.notify({
            message: 'طرف معامله دارای سفارش تایید نشده می باشد',
            color: 'deep-orange',
            position: 'top',
            type: 'deep-orange',
            multiLine: true
          });
        }
        this.selectedCustomer = row;
        this.$emit('customerSelected', row)
        EventBus.$emit('invoke-selected-customer', row);
        EventBus.$emit('invoke-customer-search-result-event', []);
      }
    },
    showCustomerDetails(row) {
      this.getCustomerInfo(row.Cs_ID).then((res) => {
        this.selectedCustomer = res.data[0];
        this.showCustomerFullInfo = true;
      })
    },
    sendSMS(userInfo) {
      this.selectedCustomer = userInfo
      this.showSMSPanel = true
    },
    setCurrentCustomerLocation(customerInfo) {
      this.$getLocation({
        timeout: Infinity
      }).then(coordinates => {
        this.setCurrentLocation({
          Cs_ID: customerInfo.Cs_ID,
          latitude: coordinates.lat,
          longitude: coordinates.lng,
          accuracy: coordinates.accuracy
        }).then(() => {
          this.$q.notify({
            message: 'موقعیت جغرافیایی طرف معامله به ثبت رسید',
            color: 'positive',
            position: 'top',
            type: 'positive'
          });
        });
      }).catch(() => {
        this.$q.notify({
          message: 'امکان دریافت موقعیت جغرافیایی طرف معامله وجود ندارد',
          color: 'negative',
          position: 'top',
          type: 'negative'
        });
      });
    },
  },
  watch: {
    selectedCities: function (value) {
      if (value) {
        this.customerList = this.items.filter(item => item.City_Name !== null && value.includes(item.City_Name));
      } else {
        this.customerList = this.items
      }
    }
  },
  created() {
    if (this.items.length > 0) {
      this.customerList = this.items;
      this.cityList = this.lodash.uniq(this.customerList.map(item => item.City_Name))
      this.cityListOptions = this.cityList
    }
  },
  mounted() {
    if (this.items.length === 0) {
      EventBus.$on('invoke-customer-search-result-event', payload => {
        this.customerList = payload;
      });
      EventBus.$on('invoke-selected-customer', payload => {
        this.selectedCustomer = payload;
      });
    }
  }
}
</script>
<style lang="sass">
.my-sticky-header-table
  /* height or max-height is important */
  height: 75vh

  .q-table__top,
  .q-table__bottom,
  thead tr:first-child th
    /* bg color is important for th; just specify one */
    background-color: #455a64
    color: white

  thead tr th
    position: sticky
    z-index: 1

  thead tr:first-child th
    top: 0

  /* this is when the loading indicator appears */




  &.q-table--loading thead tr:last-child th
    /* height of all previous header rows */
    top: 48px

  /* prevent scrolling behind sticky top row on focus */




  tbody
    /* height of all previous header rows */
    scroll-margin-top: 48px
</style>
